"use strict";

var _interopRequireDefault = require("/codebuild/output/src3029718028/src/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getPageTitle;
require("core-js/modules/es.array.concat.js");
var _settings = _interopRequireDefault(require("@/settings"));
var title = _settings.default.title || 'Vue Element Admin';
function getPageTitle(pageTitle) {
  if (pageTitle) {
    return "".concat(pageTitle, " - ").concat(title);
  }
  return "".concat(title);
}